import React, { useEffect } from "react";
import taller from "../../assets/icon_mapa/taller.svg";
import ventas from "../../assets/icon_mapa/ventas.svg";
import waze from "../../assets/icon_mapa/waze.svg";
import google from "../../assets/icon_mapa/google_maps.svg";
import my_location from "../../assets/icon_mapa/location_icon.svg";
import phone from "../../assets/icon_mapa/phone.svg";

/*eslint-disable */

declare const window: any;

interface ContenidoOpcionesComponentProps {
  ciudad: any;
  setCiudad: any;
  vitrina: any;
  setVitrina: any;
  vehiculo: any;
  setVehiculo: any;
  concesionarios: any;
  selectedConcesionarios: any;
  setSelectedConcesionarios: any;
  setPalabra: any;
  palabra: any;
  setMylocation: any;
  mylocation: any;
  handleOpenModal: any;
  selectedDealer: any;
  onSelectDealer: any;
}

const ciudades: any = [
  {
    ciudad: "Colombia",
    coordenadas: { lat: 4.5, lng: -74.0 },
    zoom: 6,
  }, // Centro de Colombia
  {
    ciudad: "Bogotá",
    coordenadas: { lat: 4.61, lng: -74.083 },
    zoom: 12,
  },
  { ciudad: "Armenia", coordenadas: { lat: 4.5339, lng: -75.6813 }, zoom: 12 },
  { ciudad: "Medellín", coordenadas: { lat: 6.2442, lng: -75.5812 }, zoom: 12 },
  { ciudad: "Cali", coordenadas: { lat: 3.4516, lng: -76.532 }, zoom: 12 },
  {
    ciudad: "Villavicencio",
    coordenadas: { lat: 4.1427, lng: -73.6344 },
    zoom: 12,
  },
  { ciudad: "Tunja", coordenadas: { lat: 5.5403, lng: -73.3672 }, zoom: 12 },
  {
    ciudad: "Barranquilla",
    coordenadas: { lat: 10.9685, lng: -74.7813 },
    zoom: 12,
  },
  {
    ciudad: "Cartagena de Indias",
    coordenadas: { lat: 10.391, lng: -75.4794 },
    zoom: 12,
  },
  {
    ciudad: "Santa Marta",
    coordenadas: { lat: 11.2408, lng: -74.1999 },
    zoom: 12,
  },
  {
    ciudad: "Valledupar",
    coordenadas: { lat: 10.4633, lng: -74.1898 },
    zoom: 12,
  },
  {
    ciudad: "Palmira",
    coordenadas: { lat: 3.53944, lng: -76.30363 },
    zoom: 12,
  },
  { ciudad: "Tuluá", coordenadas: { lat: 4.0969, lng: -76.1945 }, zoom: 12 },
  {
    ciudad: "Manizales",
    coordenadas: { lat: 5.0717, lng: -75.5134 },
    zoom: 12,
  },
  { ciudad: "Pereira", coordenadas: { lat: 4.8142, lng: -75.6961 }, zoom: 12 },
  {
    ciudad: "Bucaramanga",
    coordenadas: { lat: 7.1189, lng: -73.1217 },
    zoom: 12,
  },
  {
    ciudad: "Montería",
    coordenadas: { lat: 8.74798, lng: -75.88143 },
    zoom: 12,
  },
  { ciudad: "Cúcuta", coordenadas: { lat: 7.8933, lng: -72.5078 }, zoom: 12 },
  { ciudad: "Chía", coordenadas: { lat: 4.8616, lng: -74.0383 }, zoom: 12 },
  {
    ciudad: "Rionegro",
    coordenadas: { lat: 6.155, lng: -75.373 },
    zoom: 12,
  },
  {
    ciudad: "Itagüi",
    coordenadas: { lat: 6.1846, lng: -75.5994 },
    zoom: 12,
  },
  { ciudad: "Pasto", coordenadas: { lat: 1.2133, lng: -77.2839 }, zoom: 12 },
  { ciudad: "Neiva", coordenadas: { lat: 2.9706, lng: -75.3205 }, zoom: 12 },
  { ciudad: "Ibagué", coordenadas: { lat: 4.4384, lng: -75.2024 }, zoom: 12 },
];

const ContenidoOpcionesComponent: React.FC<ContenidoOpcionesComponentProps> = ({
  ciudad,
  setCiudad,
  vitrina,
  setVitrina,
  vehiculo,
  setVehiculo,
  concesionarios,
  selectedConcesionarios,
  setSelectedConcesionarios,
  setPalabra,
  palabra,
  setMylocation,
  mylocation,
  handleOpenModal,
  selectedDealer,
  onSelectDealer,
}) => {
  useEffect(() => {
    const filteredConcesionarios = concesionarios.filter((e: any) => {
      const matchesPalabra =
        palabra === "" || e.name.toLowerCase().includes(palabra.toLowerCase());
      const matchesCiudad =
        ciudad === "Colombia" || ciudad === "todo" || e.city === ciudad;

      // Lógica para filtrar por vitrina
      const matchesVitrina =
        vitrina === "ventas/taller" || // Si es ventas/taller, tomamos todos
        (vitrina === "ventas" && e.is_sales_room) || // Si es ventas, solo donde is_sales_room = true
        (vitrina === "taller" && e.is_workshop); // Si es taller, solo donde is_workshop = true

      return matchesPalabra && matchesCiudad && matchesVitrina;
    });

    setSelectedConcesionarios(filteredConcesionarios);
  }, [ciudad, vitrina, vehiculo, palabra, concesionarios]);

  useEffect(() => {
    if (selectedDealer) {
      const element = document.getElementById(`${selectedDealer.name}-${selectedDealer.id}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [selectedDealer]);

  const ciudadesUnicas: any = Array.from(
    new Set(concesionarios.map((item: any) => item.city))
  );

  return (
    <div className="contenido-opciones-concesionarios-component">
      <div className="filtro-contenido-opciones-concesionarios-component">
        <div className="input-small-filtro-contenido-opciones-concesionarios-component">
          <label htmlFor="">Selecciona una ciudad</label>
          <select
            name=""
            id=""
            value={ciudad}
            onChange={(e) => {
              setCiudad(e.target.value);
            }}
          >
            <option key={"firts-1"} value={"Colombia"}>
              Colombia
            </option>
            {ciudadesUnicas.map((ciudad: any, index: any) => (
              <option key={index} value={ciudad}>
                {ciudad}
              </option>
            ))}
          </select>
        </div>
        <div className="input-small-filtro-contenido-opciones-concesionarios-component">
          <label htmlFor="">Tipo de vitrina</label>
          <select
            name=""
            id=""
            value={vitrina}
            onChange={(e) => {
              setVitrina(e.target.value);
            }}
          >
            <option value="ventas/taller">Venta y Talleres</option>
            <option value="taller">Talleres</option>
            <option value="ventas">Ventas</option>
          </select>
        </div>
        <div className="input-large-filtro-contenido-opciones-concesionarios-component">
          <label htmlFor="">Buscar concesionario por palabra clave</label>
          <input
            type="text"
            onChange={(e) => {
              setPalabra(e.target.value);
            }}
          />
        </div>
        <div
          className="my-location-filtro-contenido-opciones-concesionarios-component"
          onClick={() => setMylocation(!mylocation)}
        >
          <img src={my_location} alt="Ubicacion" />
          Usar mi ubicación
        </div>
      </div>
      <div className="resultados-contenido-opciones-concesionarios-component">
        <div className="ciudad-resultados-contenido-opciones-concesionarios-component">
          {ciudad === "todo" ? "Colombia" : ciudad} (
          {selectedConcesionarios?.length})
        </div>
        {selectedConcesionarios?.map((item: any) => (
          <div
            className={`concesionario-resultados-contenido-opciones-concesionarios-component ${
              selectedDealer?.name === item?.name &&
              selectedDealer?.id === item?.id
                ? "active"
                : ""
            }`}
            onClick={() => onSelectDealer(item)}
            id={`${item?.name}-${item?.id}`}
          >
            <div className="header">
              <div className="title-header">
                <img
                  src={`${item?.is_sales_room ? ventas : taller}`}
                  alt="Ventas y Taller Hyundai Colombia"
                />
                {item?.is_sales_room ? "Ventas" : "Taller"}
              </div>
              {item?.doty?.url ? (
                <div className="sello-header" onClick={handleOpenModal}>
                  <img
                    src={`https://manager.hyundaicolombia.co/${item?.doty?.url}`}
                    alt="Doty Hyundai Colombia"
                  />
                </div>
              ) : null}
            </div>
            <div className="title">{item?.name}</div>
            {/* <div className="categorias">
              <ul>
                <li>Particulares</li>
                <li>Comerciales y públicos</li>
                <li>Taxi</li>
              </ul>
            </div> */}
            <div className="contenido">
              <div className="top">
                <div className="direccion">{item?.address}</div>
                <div className="btns">
                  {item?.url_waze ? (
                    <a
                      href={item?.url_waze}
                      style={{ textDecoration: "none" }}
                      target="_blank"
                    >
                      <img src={waze} alt="Waze" /> Waze
                    </a>
                  ) : null}
                  {item?.url_googlemaps ? (
                    <a
                      href={item?.url_googlemaps}
                      style={{ textDecoration: "none" }}
                      target="_blank"
                    >
                      <img src={google} alt="Google" /> Google
                    </a>
                  ) : null}
                </div>
              </div>
              <div className="horarios">
                {item?.schedule_monday_to_friday ? (
                  <div className="horario">
                    <div className="subtitle">Lunes a Viernes</div>
                    <div className="title">
                      {item?.schedule_monday_to_friday}
                    </div>
                  </div>
                ) : null}
                {item?.schedule_saturday ? (
                  <div className="horario">
                    <div className="subtitle">Sábados</div>
                    <div className="title">{item?.schedule_saturday}</div>
                  </div>
                ) : null}
                {item?.schedule_sunday ? (
                  <div className="horario">
                    <div className="subtitle">Domingos</div>
                    <div className="title">{item?.schedule_sunday}</div>
                  </div>
                ) : null}
              </div>
              <div className="emails">
                {item?.email1 ? <div>{item?.email1}</div> : null}
                {item?.email2 ? <div>{item?.email2}</div> : null}
                {item?.email3 ? <div>{item?.email3}</div> : null}
              </div>
              <div className="telefonos">
                {item?.phone1 ? (
                  <div>
                    <a href={`tel:${item.phone1}`}>
                      <img src={phone} alt="Telefono" />
                      {item.phone1}
                    </a>
                  </div>
                ) : null}
                {item?.phone2 ? (
                  <div>
                    <a href={`tel:${item.phone2}`}>
                      <img src={phone} alt="Telefono" />
                      {item.phone2}
                    </a>
                  </div>
                ) : null}
                {item?.phone3 ? (
                  <div>
                    <a href={`tel:${item.phone3}`}>
                      <img src={phone} alt="Telefono" />
                      {item.phone3}
                    </a>
                  </div>
                ) : null}
              </div>
              {item?.url ? (
                <a href={item?.url} target="blank" className="btn-agenda">
                  {item?.is_sales_room
                    ? "Contáctanos a través de whatsapp"
                    : "Agenda tu Cita Taller"}
                </a>
              ) : null}
              {item?.go_to_website ? (
                <a
                  href={item?.go_to_website}
                  target="blank"
                  className="btn-agenda mt-2"
                >
                  Ir al Sitio Web
                </a>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContenidoOpcionesComponent;
